// extracted by mini-css-extract-plugin
export default {"root":"FiltersSection_root__1vrdC","filterItem":"FiltersSection_filterItem__h8aut"};